import { useIntl } from 'platform-components';
import React from 'react';
import { useSelector } from 'react-redux';

import { getIsEvaluable } from 'common.components/lesson-view.index/__meta/selectors';

import { SpecCourseLessonViewRulesBlock } from '../__rules-block/spec-course-lesson-view__rules-block';

import './spec-course-lesson-view__rules-block-wrapper.scss';

export const SpecCourseLessonViewRulesBlockWrapper = () => {
    const intl = useIntl();
    const isEvaluable = useSelector(getIsEvaluable);

    const countTextId = isEvaluable ? 'specCourse.Rules.Block.count.controlWork' : 'specCourse.Rules.Block.count';
    const count = Number(intl.formatMessage({ id: countTextId }));
    const blocks = new Array(count).fill(1).map((el, index) => index + el);

    return (
        <div className="spec-course-lesson-view__rules-block-wrapper">
            {blocks.map((block) => (
                <SpecCourseLessonViewRulesBlock
                    blockIndex={block}
                    description={intl.formatMessage({ id: `specCourse.Rules.Block.${block}.description` })}
                    key={block}
                    title={intl.formatMessage({ id: `specCourse.Rules.Block.${block}.title` })}
                />
            ))}
        </div>
    );
};
